export const SET_HEADER = "SET_HEADER";
export const RESET_HEADER = "RESET_HEADER";

export const TOGGLE_CARD_VIEW = "TOGGLE_CARD_VIEW";

export const TOGGLE_FILTERS_DRAWER = "TOGGLE_FILTERS_DRAWER";
export const TOGGLE_SIDER = "TOGGLE_SIDER";
export const CHANGE_SEARCH_VALUE = "CHANGE_SEARCH_VALUE";
export const CLEAR_SEARCH_VALUE = "CLEAR_SEARCH_VALUE";
export const ON_MONTH_SELECT = "ON_MONTH_SELECT";
